import React, { useContext, useState } from "react";
import useDB from "../../hooks/useDB";
import Loading from "../../components/Loading";
import Error from "../../components/Error";
import { DataGrid } from "@mui/x-data-grid";
import HtTabs from "../../components/HtTabs";
import { CenterContext, StaffContext } from "../../../../Context";
import Info from "../../components/Info";
import SelectFromList from "../../components/SelectFromList";
import SetTargetDialog from "./SetTargetDialog";
import Search from "../../components/Search";
import {  useNavigate } from "react-router-dom";
import Weekday from "../student/components/Weekday";



export default function ClassList() {


    const [classes, setClasses, error, loading] = useDB(`/classlist`)
  const { center } = useContext(CenterContext)
  
   


if (loading) return <Loading />;
if (error) return <Error />;

console.log(classes)

    const labels = center.locations.filter(l => l.name !== "All locations").map(l => `${l.name} (${ classes.filter(c => c.location === l._id).length })`)
    const components = center.locations.filter(l => l.name !== "All locations").map(l => <DrawTable classes={classes.filter(c=>c.location===l._id)} setClasses={setClasses}/>)

    return (<div>
        <HtTabs components={components} labels={labels} localStorage/>
</div>)
}

function DrawTable({ classes, setClasses }) {
  const navigate = useNavigate()
    const {findStaffName} = useContext(StaffContext)
  const [teacher, setTeacher] = useState("")
  const [selectedClass, setSelectedClass] = useState(undefined)
  const [search,setSearch] = useState("")
    let rows = classes
      .filter((c) => {
        if (!teacher) return true;
        if (teacher === c.teacher) return true;
        return false;
      })
      .filter(
        (c) =>
          search === "" ||
          c.name.toLocaleLowerCase().includes(search.toLocaleLowerCase())
      )
      .map((c) => ({
        id: c._id,
        name: c.name,
        schedule: c.classDays,
        students: c.students.length,
        pending: c.pendingStudents.length,
        target: c.maxStudents,
        space: c.maxStudents
          ? c.maxStudents - c.students.length - c.pendingStudents.length
          : "",
        syllabus: c.syllabus && c.syllabus.name ? c.syllabus.name : c.syllabus,
        ages: c.syllabus
          ? `${c.syllabus.ageFrom} - ${c.syllabus.ageTo}`
          : "TBA",
        moveToNextLevel: c.moveToNextLevel
          ? new Date(c.moveToNextLevel).fDate()
          : "",
        nextSyllabus: c.nextSyllabus && c.nextSyllabus.name ? c.nextSyllabus.name : "",
      }));

    let teachers = []
    for (let c of classes) {
        let t = teachers.find(t => t._id === c.teacher)
      if (!t) teachers.push({ _id: c.teacher, name: `${findStaffName(c.teacher)} (${classes.filter(cl => cl.teacher === c.teacher).length})` })
     
    }
    
  
  
  /*   console.log(classes.filter(c=>c.name==="EOW4B/L")[0].syllabus) */
    const columns = [
      { field: "id", width: 0 },
      {
        field: "name",
        headerName: "Name",
        width: 150,
      },
      {
        field: "schedule",
        headerName: "Schedule",
        width: 200,
        renderCell: (props) => (
          <div>
            {props.value
              .sort((a, b) => (a.day > b.day ? 1 : b.day > a.day ? -1 : 0))
              .map((cd) => (
                <div>
                  <Weekday id={cd.day} /> {cd.startTime} - {cd.endTime}
                </div>
              ))}
          </div>
        ),
      },
      {
        field: "students",
        headerName: "Students",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "pending",
        headerName: "Pending",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "target",
        headerName: "Target",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "space",
        headerName: "Space",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "syllabus",
        headerName: "Program",
        width: 150,
      },
      {
        field: "moveToNextLevel",
        headerName: "Next level starts",
        width: 150,
      },
      {
        field: "nextSyllabus",
        headerName: "Next program",
        width: 150,
      },
      {
        field: "ages",
        headerName: "Ages",
        width: 150,
      },
    ];


  return <div /* style={{height:"100vh"}} */><Totals classes={classes} setTeacher={setTeacher} teachers={teachers} search={search} setSearch={setSearch}/>
    <DataGrid rows={rows} columns={columns} autoHeight initialState={{
    columns: {
      columnVisibilityModel: {
        id: false,
        },
     
    },
    }}
      onRowClick={r => navigate(`/class/${r.id}`)}
    />
      {selectedClass ?
        <SetTargetDialog open={selectedClass} setOpen={setSelectedClass} update={htClass => {
        setClasses(prev=> [...prev.map(p=>p._id===htClass._id ? htClass : p)])
      }} />
        : null}
    </div>
}

function Totals({ classes, teachers, setTeacher, teacher,search,setSearch }) {
    let total = classes.reduce((a,b)=> a + (b.students.length + b.pendingStudents.length),0)
    let target = classes.reduce((a,b)=> b.maxStudents ? a + b.maxStudents : a+0,0)
    return <div style={{ display: "flex", gap: 20, marginBottom: 5 }}>
        <Info title="Students" body={total} style={{ width: 100 }} />
        <Info title="Target" body={target} style={{ width: 100 }}/>
        <Info title="Space" body={target - total} style={{ width: 100 }} />
      <SelectFromList choices={teachers} value={teacher} setValue={setTeacher} label="Teachers" size="small" style={{ width: 200 }} none />
      <Search search={search} setSearch={setSearch} size="small" />
    </div>
}


  